import { useState, useEffect } from "react";
import { Link } from "react-router-dom";

const navLinks = [
  { label: "HOME", path: "/" },
  { label: "事業内容", path: "/business" },
  { label: "会社概要", path: "/company" },
  { label: "採用情報", path: "/recruit" },
  { label: "NEWS", path: "/news" },
];

export default function Header() {
  const [scrolled, setScrolled] = useState(false);
  const [mobileOpen, setMobileOpen] = useState(false);
  const [hoveredLink, setHoveredLink] = useState<string | null>(null);
  const [contactHovered, setContactHovered] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 40);
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <>
      <header
        className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
          scrolled
            ? "bg-navy/95 backdrop-blur-md py-3 shadow-lg"
            : "bg-transparent py-5"
        }`}
      >
        <div className="w-full px-4 md:px-8 flex items-center justify-between">
          <Link to="/" className="flex items-center gap-3">
            <img
              src="/images/logo.png"
              alt="株式会社GRANSTARKのロゴ"
              className="h-10 md:h-12 w-auto object-contain"
            />
            <div>
              <span className="text-white font-bold text-base md:text-lg tracking-wide block">GRANSTARK</span>
              <span className="text-[9px] md:text-[10px] text-white/80 font-normal tracking-widest block mt-[-2px]">グランシュターク</span>
            </div>
          </Link>

          <nav className="hidden lg:flex items-center gap-8">
            {navLinks.map((link) => (
              <Link
                key={link.path}
                to={link.path}
                className="text-white text-sm tracking-wider relative py-2"
                onMouseEnter={() => setHoveredLink(link.path)}
                onMouseLeave={() => setHoveredLink(null)}
              >
                {link.label}
                <span
                  className="absolute bottom-0 left-0 h-0.5"
                  style={{
                    width: hoveredLink === link.path ? '100%' : '0',
                    backgroundColor: '#c9a84c',
                    transition: 'width 0.3s',
                  }}
                />
              </Link>
            ))}
          </nav>

          <div className="hidden lg:block">
            <Link
              to="/contact"
              className="text-white font-bold text-sm px-7 py-3 rounded-lg whitespace-nowrap"
              onMouseEnter={() => setContactHovered(true)}
              onMouseLeave={() => setContactHovered(false)}
              style={{
                backgroundColor: contactHovered ? 'rgba(228,121,17,0.85)' : '#E47911',
                transform: contactHovered ? 'translateY(-2px)' : 'translateY(0)',
                transition: 'background-color 0.3s, transform 0.3s',
                cursor: 'pointer',
                display: 'inline-block',
              }}
            >
              お問い合わせ
            </Link>
          </div>

          <button
            className="lg:hidden text-white p-2 flex items-center justify-center cursor-pointer"
            onClick={() => setMobileOpen(!mobileOpen)}
            aria-label="メニュー"
          >
            <div className="w-6 h-6 flex flex-col justify-center items-center gap-1.5">
              <span
                className={`block h-0.5 w-6 bg-white transition-all duration-300 ${
                  mobileOpen ? "rotate-45 translate-y-2" : ""
                }`}
              />
              <span
                className={`block h-0.5 w-6 bg-white transition-all duration-300 ${
                  mobileOpen ? "opacity-0" : ""
                }`}
              />
              <span
                className={`block h-0.5 w-6 bg-white transition-all duration-300 ${
                  mobileOpen ? "-rotate-45 -translate-y-2" : ""
                }`}
              />
            </div>
          </button>
        </div>
      </header>

      {mobileOpen && (
        <div className="fixed inset-0 z-40 bg-gray-900/85 backdrop-blur-sm flex flex-col items-center justify-center gap-8">
          {navLinks.map((link) => (
            <Link
              key={link.path}
              to={link.path}
              onClick={() => setMobileOpen(false)}
              className="text-white text-xl tracking-wider"
            >
              {link.label}
            </Link>
          ))}
          <Link
            to="/contact"
            onClick={() => setMobileOpen(false)}
            className="bg-[#E47911] text-white font-bold text-lg px-8 py-4 rounded-lg mt-4"
          >
            お問い合わせ
          </Link>
        </div>
      )}
    </>
  );
}